import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { AgricolaToastType } from '../../../interfaces/agricola.interface';

@Component({
  selector: 'app-agricola-toast',
  templateUrl: './agricola-toast.component.html',
  styleUrls: ['./agricola-toast.component.css'],
  standalone: false
})
export class AgricolaToastComponent implements OnInit {

  @Input() message: string = '';
  @Input() type: AgricolaToastType = 'error';
  @Input() show: boolean = false;
  @Output() close = new EventEmitter<void>();

  constructor() { }

  ngOnInit(): void {
  }

  onClose(): void {
    this.close.emit();
  }

  getIconClass(): string {
    switch (this.type) {
      case 'error':
        return 'fas fa-exclamation';
      case 'success':
        return 'fas fa-check-circle';
      case 'warning':
        return 'fas fa-exclamation-triangle';
      case 'info':
        return 'fas fa-info-circle';
      default:
        return 'fas fa-exclamation';
    }
  }

}
